import { shouldShowUpsell } from 'owa-proofing-option/lib/utils/shouldShowUpsell';
import UserOptions from 'owa-proofing-option/lib/store/schema/UserOptions';
import { isProofingSupportLocale } from 'owa-proofing-option';

/**
 * don't show Skittle when user has all corrections off
 * don't show Skittle when the locale is not supported
 */

export function skittleEnabled(
    settings: UserOptions | undefined,
    checkForSettings: boolean
): boolean {
    if (checkForSettings) {
        return (
            shouldShowUpsell() &&
            (settings?.spellCheckEnabled || settings?.grammarEnabled) &&
            isProofingSupportLocale(settings?.proofingLocale)
        );
    } else {
        return shouldShowUpsell();
    }
}
